<template>
    <div class="onboarding-roulette__wrapper">
        <img class="onboarding-roulette__bg-top" src="@/pages/casino/rouletteGame/img/introduction/top-bg.png"  />
        <img class="onboarding-roulette__bg-bottom" src="@/pages/casino/rouletteGame/img/introduction/bottom-bg.png"  />
        <img class="onboarding-roulette__palm-decor" src="@/pages/casino/rouletteGame/img/introduction/palm.webp"  />
        <!-- ↑图 -->
        <div class="onboarding-roulette__preview">
            <img class="onboarding-roulette__chip-red" src="@/pages/casino/rouletteGame/img/introduction/chips-red.webp"  />
            <img class="onboarding-roulette__chip-blue" src="@/pages/casino/rouletteGame/img/introduction/chips-blue.webp"  />
            <div class="onboarding-roulette__preview-info">
                <h2 class="onboarding-roulette__preview-title">
                    <!-- Experience the classic Roulette -->
                    {{$t('roulette.previewTitle')}}
                </h2>
                <p class="onboarding-roulette__preview-subtitle">
                    <!-- Play the new Original game -->
                    {{$t('roulette.previewSubtitle')}}
                </p>
                <p class="onboarding-roulette__preview-desc">
                    <!-- Discover the iconic European Roulette on BetCorgi. Place
                    your bets, feel the thrill, and watch as the ball lands
                    on one of the 37 numbers. Let the wheel determine your fate! -->
                    {{$t('roulette.previewDesc')}}
                </p>
            </div>
            <div class="onboarding-roulette__preview-banner">
                <img class="onboarding-roulette__preview-image" src="@/pages/casino/rouletteGame/img/introduction/banner.webp"  />
            </div>
        </div>
        <!-- 
            === ❤️❤️❤️ 腰部标记 ❤️❤️❤️ =====================
        --> 
        <div class="onboarding-roulette__feature">
            <h2 class="onboarding-roulette__feature-title">
                <!-- Enjoy endless winning possibilities -->
                {{$t('roulette.featureTitle')}}
            </h2>
            <p class="onboarding-roulette__feature-desc">
                <!-- Immerse yourself in the gameplay with the different
                features and explore a variety of inside, outside, and section bets. -->
                {{$t('roulette.featureDesc')}}
            </p>
            <!-- ↓ 特性陈列  -->
            <div class="onboarding-roulette__feature-list">
                <div class="onboarding-roulette__feature-item">
                    <img class="onboarding-roulette__item-icon" src="@/assets/imgs/introduction/hand-icon.png"  />
                    <span class="onboarding-roulette__item-name">
                        <!-- Drag’n’drop feature -->
                        {{$t('roulette.dragAndDrop')}}
                    </span>
                </div>
                <div class="onboarding-roulette__feature-item">
                    <img class="onboarding-roulette__item-icon" src="@/assets/imgs/introduction/arrow-icon.png"  />
                    <span class="onboarding-roulette__item-name">
                        RTP {{ '97,3%' }}
                    </span>
                </div>
                <div class="onboarding-roulette__feature-item">
                    <img class="onboarding-roulette__item-icon" src="@/assets/imgs/introduction/play-icon.png"  />
                    <span class="onboarding-roulette__item-name">
                        <!-- Section bets -->
                        {{$t('roulette.sectionBets')}}
                    </span>
                </div>
            </div>
            <!-- ↓大图 -->
            <div class="onboarding-roulette__feature-board">
                <picture class="onboarding-roulette__board-image" >
                    <source media="(min-width: 769px)" srcset="@/pages/casino/rouletteGame/img/introduction/board.webp" />
                    <img src="@/pages/casino/rouletteGame/img/introduction/board-mob.webp"  />
                </picture>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'contentRoulette',
}
</script>


<style lang="scss" scoped>
.onboarding-roulette__bg-top {
    left: -24px;
    max-width: calc(100% + 48px);
    position: absolute;
    right: -24px;
    top: 0
}

@media (max-width: 768px) {
    .onboarding-roulette__bg-top {
        top:15px
    }
}

.onboarding-roulette__bg-bottom {
    bottom: 0;
    left: -24px;
    max-width: calc(100% + 48px);
    position: absolute;
    right: -24px
}

.onboarding-roulette__wrapper {
    padding-bottom: 32px;
    position: relative;
    z-index: 2
}

@media (max-width: 768px) {
    .onboarding-roulette__wrapper {
        padding-top:70px
    }
}

.onboarding-roulette__preview {
    align-items: center;
    display: flex;
    position: relative
}

.onboarding-roulette__chip-red {
    left: 37px;
    position: absolute;
    top: 14px;
    width: 105px
}

@media (max-width: 768px) {
    .onboarding-roulette__chip-red {
        left:0;
        top: -87px;
        width: 98px
    }
}

.onboarding-roulette__chip-blue {
    bottom: 14px;
    left: 136px;
    position: absolute;
    width: 75px
}

@media (max-width: 768px) {
    .onboarding-roulette__chip-blue {
        bottom:-85px;
        left: auto;
        right: 0;
        width: 55px
    }
}

.onboarding-roulette__preview-info {
    padding-top: 10px;
    position: relative;
    width: 55%
}

@media (max-width: 768px) {
    .onboarding-roulette__preview-info {
        text-align:center;
        width: 100%;
        z-index: 2
    }
}

.onboarding-roulette__preview-banner {
    margin-right: -24px;
    max-width: 340px;
    width: 100%
}

@media (max-width: 768px) {
    .onboarding-roulette__preview-banner {
        left:50%;
        position: absolute;
        top: 17%;
        transform: translate(-50%);
        width: 315px
    }
}

.onboarding-roulette__preview-title {
    color: #df9bff;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -.48px;
    line-height: 135%;
    margin-bottom: 20px
}

@media (max-width: 768px) {
    .onboarding-roulette__preview-title {
        margin:0 auto;
        max-width: 310px
    }
}

.onboarding-roulette__preview-subtitle {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -.36px;
    line-height: 135%;
    margin-bottom: 12px
}

@media (max-width: 768px) {
    .onboarding-roulette__preview-subtitle {
        margin-bottom:299px
    }
}

.onboarding-roulette__preview-desc {
    color: #93acd3;
    font-size: 12px;
    font-weight: 500;
    line-height: 150%;
    margin-bottom: 0;
    max-width: 370px
}

@media (max-width: 768px) {
    .onboarding-roulette__preview-desc {
        margin:0 auto
    }
}

.onboarding-roulette__feature {
    padding-top: 32px;
    position: relative;
    min-height: 400px; // 后补
}


@media (max-width: 768px) {
    .onboarding-roulette__feature {
        padding-top:112px
    }
}

.onboarding-roulette__feature-title {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -.36px;
    line-height: 135%;
    margin-bottom: 12px;
    text-align: center
}

@media (max-width: 768px) {
    .onboarding-roulette__feature-title {
        letter-spacing:-.4px
    }
}

.onboarding-roulette__feature-desc {
    color: #93acd3;
    font-size: 12px;
    font-weight: 500;
    line-height: 150%;
    margin: 0 auto 24px;
    max-width: 512px;
    text-align: center
}

.onboarding-roulette__feature-list {
    align-items: center;
    display: flex;
    gap: 20px;
    margin-bottom: 14px
}

@media (max-width: 768px) {
    .onboarding-roulette__feature-list {
        flex-direction:column;
        margin-bottom: 32px
    }
}

.onboarding-roulette__feature-item {
    align-items: center;
    -webkit-backdrop-filter: blur(9.5px);
    backdrop-filter: blur(9.5px);
    background: #4e5ec74d;
    border: 2px solid hsla(0,0%,100%,.04);
    border-radius: 8px;
    display: flex;
    flex: 1;
    gap: 8px;
    padding: 8px
}

@media (max-width: 768px) {
    .onboarding-roulette__feature-item {
        justify-content:center;
        width: 100%
    }
}

.onboarding-roulette__item-icon {
    width: 24px
}

.onboarding-roulette__item-name {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -.24px;
    line-height: 130%;
    margin-bottom: 0
}

.onboarding-roulette__feature-board {
    margin: auto;
    max-width: 452px
}


.onboarding-roulette__palm-decor {
    bottom: 0;
    display: none;
    left: -24px;
    max-width: calc(100% + 48px);
    pointer-events: none;
    position: absolute;
    right: -24px;
    z-index: 2
}

@media (max-width: 768px) {
    .onboarding-roulette__palm-decor {
        display:block
    }
}

</style>

